import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import {
    startLoading,
    stopLoading,
    enqueueSnackbar,
    getProfileUserSuccess,
    impersonateSuccess,
    setLocale,
    loginError
} from '../root/actions'
import axios from 'axios'
import { getSagasMsgs } from '../root/selectors'
import { decodeJwt } from 'web/src/utils'
import { LOCALE_MAP } from '../root/constants'

export const watchCustomersSaga = [
    takeLatest(actions.GET_CUSTOMERS_REQUEST, getCustomers),
    takeLatest(actions.GET_CUSTOMER_REQUEST, getCustomer),
    takeLatest(actions.UPDATE_CUSTOMER_REQUEST, updateCustomer),
    takeLatest(actions.IMPERSONATE_USER, impersonateUser)
]

function* impersonateUser(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())

        const response = yield call(
            impersonateUserRequest,
            action.payload.userIdToImpersonate
        )

        const decoded = decodeJwt(response.data)
        yield put(
            impersonateSuccess(
                response.data,
                decoded.iss.user,
                decoded.permissions,
                decoded.impersonation
            )
        )
        yield put(setLocale(LOCALE_MAP[decoded.iss.user.language]))
        const profileUser = yield call(getUserRequest, decoded.iss.user.id)
        yield put(getProfileUserSuccess(profileUser))
        window.location.href = '/dashboard'

        yield put(stopLoading())
    } catch (ex) {
        console.log(ex)
        yield put(loginError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.impersonationError,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getUserRequest(userId) {
    const response = await axios.get(`${process.env.API_URL}/users/${userId}`)
    return response.data
}

async function impersonateUserRequest(userIdToImpersonate) {
    const response = await axios.post(
        `${process.env.API_URL}/users/impersonate`,
        { userId: userIdToImpersonate }
    )
    return response
}

function* getCustomers() {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(getCustomersRequest)
        yield call(getSoftwarePlans)
        yield put(actions.getCustomersSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.getCustomersError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getCustomersEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getCustomersRequest() {
    const response = await axios.get(`${process.env.API_URL}/customers`)
    return response.data
}

function* getCustomer(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(getCustomerRequest, action.customerId)
        yield call(getSoftwarePlans)
        yield put(actions.getCustomerSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.getCustomerError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getCustomerEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getCustomerRequest(customerId) {
    const response = await axios.get(
        `${process.env.API_URL}/customers/${customerId}`
    )
    return response.data
}

function* updateCustomer(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(updateCustomerRequest, action.customerId, action.body)
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateCustomerRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.updateCustomerSuccess())
        yield put(actions.getCustomerRequest(action.customerId))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.updateCustomerError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateCustomerEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function updateCustomerRequest(customerId, body) {
    await axios.patch(`${process.env.API_URL}/customers/${customerId}`, body)
}

function* getSoftwarePlans() {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        // supplementary fetch for customers, no need to
        // set isLoading
        yield put(actions.getSoftwarePlansRequest())
        const response = yield call(getSoftwarePlansRequest)
        yield put(actions.getSoftwarePlansSuccess(response))
    } catch (ex) {
        yield put(actions.getSoftwarePlansError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getSoftwarePlansEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function getSoftwarePlansRequest() {
    const response = await axios.get(`${process.env.API_URL}/software-plans`)
    return response.data
}
